<template>
    <div class="my-4 mx-0">
        <mapRoutingMachine :routePoints="todosLosPuntos" :apiExecuted="apiExecuted" />
        <div class="card mb-4 shadow-lg ">
            <div class="card-body p-4">
                <span class="h2"><b>¿Cómo desea añadir los puntos de entrega?</b></span>
                <div class="mt-3 d-flex justify-content-between flex-wrap">
                    <div class="selection-card-wrapper">
                        <div class="selection-card" @click="modoSeleccion = 'manual'"
                            :class="{ 'selected': modoSeleccion === 'manual' }">
                            <div class="card-content">
                                <div class="icon-wrapper">
                                    <i class="fas fa-hand-pointer fa-2x"></i>
                                </div>
                                <h3 class="text-lg font-semibold mt-3 mb-2">Manual</h3>
                                <span class="my-2 h5 margin-bottom-10"><b>Seleccione y ordene los puntos de entrega
                                        individualmente.</b></span>
                            </div>
                        </div>
                    </div>
                    <div class="selection-card-wrapper">
                        <div class="selection-card" @click="modoSeleccion = 'zonas'"
                            :class="{ 'selected': modoSeleccion === 'zonas' }">
                            <div class="card-content">
                                <div class="icon-wrapper">
                                    <i class="fas fa-map-marked-alt fa-2x"></i>
                                </div>
                                <h3 class="text-lg font-semibold mt-3 mb-2">Por Zonas</h3>
                                <span class="my-2 h5 margin-bottom-10"><b>Seleccione una zona predefinida para cargar
                                        puntos de entrega.</b></span>
                            </div>
                        </div>
                    </div>
                    <div class="selection-card-wrapper">
                        <div class="selection-card" @click="modoSeleccion = 'excel'"
                            :class="{ 'selected': modoSeleccion === 'excel' }">
                            <div class="card-content">
                                <div class="icon-wrapper">
                                    <i class="fas fa-file-excel fa-2x"></i>
                                </div>
                                <h3 class="text-lg font-semibold mt-3 mb-2">Excel</h3>
                                <span class="my-2 h5 margin-bottom-10"><b>Importe puntos de entrega desde un archivo
                                        Excel.</b></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-4">
            <div class="card-body">
                <span class="h5 font-weight-bold">Seleccionar Punto de Partida</span>
                <div class="mb-3 d-flex flex-column">
                    <v-select v-model="puntoPartidaSeleccionado" :options="plantillasRutas" label="lugarEntrega"
                        :reduce="point => point" placeholder="Seleccione un punto de partida"
                        @input="actualizarCoordenadasIniciales" :disabled="apiExecuted">
                        <template #option="{ lugarEntrega, nombreCliente, latUbicacionEntrega, longUbicacionEntrega }">
                            {{ lugarEntrega }} ---> {{ nombreCliente ? nombreCliente : "" }}
                            ({{ latUbicacionEntrega }}, {{ longUbicacionEntrega }})
                        </template>
                    </v-select>
                </div>
            </div>
        </div>

        <div v-if="modoSeleccion === 'manual'">
            <div class="mb-4">
                <div class="card-body">
                    <div class="mb-3 d-flex flex-column">
                        <span class="h3">Añadir puntos de entrega</span>
                        <MultiSelectReactivo v-model="plantillasElegidas" :options="plantillasRutasMultiSelect" valorGuardar="id"
                            valorVer=detallePlantilla emptyList="¡Lo sentimos!. No tienes plantillas creadas."
                            :selectFirst="false" :allData="true" />
                    </div>
                    <div class="d-flex justify-content-between">
                        <button @click="limpiarTodasLasRutas()" class="btn btn-danger">Limpiar todas las rutas</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-else-if="modoSeleccion === 'zonas'">
            <div class="mb-4">
                <div class="card-body">
                    <div class="mb-3 d-flex flex-column">
                        <span class="h3 mb-3">Seleccionar zona</span>
                        <v-select required class="style-chooser" v-model="zonaSeleccionada" :options="zonas"
                            placeholder="-- selecciona una zona --"></v-select>
                    </div>
                    <div class="mb-3 d-flex flex-column">
                        <span class="h3">Añadir puntos de entrega</span>
                        <MultiSelectReactivo v-model="plantillasElegidas" :options="plantillasRutasMultiSelect" valorGuardar="id"
                            valorVer="detallePlantilla" emptyList="¡Lo sentimos!. No tienes plantillas creadas."
                            :selectFirst="false" :allData="true" />
                    </div>
                    <div class="d-flex justify-content-between">
                        <button @click="limpiarTodasLasRutas()" class="btn btn-danger">Limpiar todas las rutas</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-else-if="modoSeleccion === 'excel'">
            <div class="mb-4">
                <div class="card-body">
                    <div class="mb-3 d-flex flex-column">
                        <span class="h3 mb-3">Importar desde Excel</span>
                        <p class="text-muted mb-3">
                            Suba un archivo Excel con los IDs de los puntos de entrega y sus datos adicionales.
                            Puede descargar una plantilla con el formato correcto usando el botón de abajo.
                        </p>

                        <ExcelUploader :plantillasDisponibles="plantillasRutas"
                            :plantillasSeleccionadas="plantillasElegidas" :puntosExistentes="puntosExistentes"
                            @importar="procesarImportacion" @mensaje="mostrarMensaje" @limpiar="limpiarDatosExcel" />
                    </div>
                </div>
            </div>
        </div>

        <div class="puntos-entrega-container">
            <!-- Encabezado con contador de puntos -->
            <div class="header-summary" v-if="plantillasElegidas.length != 0">
                <div class="counter-badge">
                    <i class="fas fa-map-marker-alt mr-2"></i>
                    <span>Puntos de entrega totales: {{ plantillasElegidas.length }}</span>
                </div>
            </div>

            <div class="delivery-points-card">
                <form ref="form" @submit.prevent="saveData">
                    <draggable v-model="plantillasElegidas" @start="drag = true" @end="drag = false"
                        v-bind="dragOptions" handle=".handle" :disabled="apiExecuted" class="delivery-points-list">
                        <transition-group name="delivery-point" type="transition">
                            <div v-for="(point, index) in puntosDeEntrega" :key="index" class="delivery-point-item"
                                :class="{ 'dragging': drag && dragIndex === index }">
                                <!-- Línea de tiempo y número de punto -->
                                <div class="timeline-container">
                                    <div class="timeline-line"></div>
                                    <div class="point-number handle" :class="{ 'disabled': apiExecuted }">
                                        <span>{{ index + 1 }}</span>
                                    </div>
                                </div>

                                <!-- Información del punto de entrega -->
                                <div class="delivery-point-content">
                                    <!-- Cabecera con ID y lugar de entrega -->
                                    <div class="point-header">
                                        <div class="point-id">
                                            <div class="info-icon">
                                                <i class="fas fa-hashtag"></i>
                                            </div>
                                            <div class="info-content">
                                                <label>Número Identificación</label>
                                                <input type="text" v-model="point.numeroDocumentoEntrega"
                                                    class="form-control id-input" placeholder="ID del punto"
                                                    :disabled="apiExecuted">
                                            </div>
                                        </div>
                                        <div class="point-location">
                                            <div class="info-icon">
                                                <i class="fas fa-map-marker-alt"></i>
                                            </div>
                                            <div class="info-content">
                                                <label>Lugar de Entrega</label>
                                                <h5 class="location-title">{{ point.lugarEntrega }}</h5>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Descripción del punto -->
                                    <div class="point-description">
                                        <div class="info-icon">
                                            <i class="fas fa-align-left"></i>
                                        </div>
                                        <div class="info-content">
                                            <label>Descripción</label>
                                            <textarea v-model="point.descripcionPuntoEntrega"
                                                class="form-control description-textarea"
                                                placeholder="Añade una descripción para este punto de entrega" rows="2"
                                                :disabled="apiExecuted"></textarea>
                                        </div>
                                    </div>

                                    <!-- Información de tiempos y distancias -->
                                    <div class="delivery-info-section">
                                        <div class="info-card">
                                            <div class="info-icon">
                                                <i class="fas fa-route"></i>
                                            </div>
                                            <div class="info-content">
                                                <label>Distancia</label>
                                                <p>{{ estimacionesTiempos[index]?.distancia || 'No consultado' }}</p>
                                            </div>
                                        </div>

                                        <div class="info-card">
                                            <div class="info-icon">
                                                <i class="fas fa-traffic-light"></i>
                                            </div>
                                            <div class="info-content">
                                                <label>Tiempo con tráfico</label>
                                                <p>{{ estimacionesTiempos[index]?.duracionConTrafico || 'No consultado'
                                                    }}</p>
                                            </div>
                                        </div>

                                        <div class="info-card">
                                            <div class="info-icon">
                                                <i class="fas fa-clock"></i>
                                            </div>
                                            <div class="info-content">
                                                <label>Hora estimada</label>
                                                <p>{{ estimacionesTiempos[index]?.horaEstimada || 'No consultado' }}</p>
                                            </div>
                                        </div>

                                        <div class="info-card" v-if="apiExecuted">
                                            <div class="info-icon">
                                                <i class="fas fa-calendar-alt"></i>
                                            </div>
                                            <div class="info-content">
                                                <label>Programar hora</label>
                                                <input :id="'deliveryDateTime' + index"
                                                    @change="actualizarFechaHoraEntrega(index, $event.target.value)"
                                                    type="datetime-local" class="form-control date" required>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Botón de eliminar -->
                                <div class="action-buttons">
                                    <button v-if="!apiExecuted" @click.prevent="removePuntoEntrega(index, $event)"
                                        class="delete-button" title="Eliminar punto de entrega">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </transition-group>
                    </draggable>

                    <!-- Botones de acción -->
                    <div class="action-section">
                        <button v-if="!apiExecuted" @click.prevent="getUbicationApi()"
                            class="action-button get-times-button">
                            <i class="fas fa-location-crosshairs mr-2"></i>
                            Obtener tiempos aproximados
                        </button>

                        <button v-if="apiExecuted" class="action-button save-button" :disabled="validarFechaEntrega"
                            type="submit">
                            <i class="fas fa-truck mr-2"></i>
                            Guardar puntos de entrega
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import MultiSelectReactivo from "../../../components/MultiSelect/MultiSelectReactivo.vue";
import draggable from "vuedraggable";
import Swal from "sweetalert2";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import ExcelUploader from "./CargaMasiva/CargaExcel.vue";
import mapRoutingMachine from "../../../components/mapsLeaflet/mapRoutingMachine.vue";

export default {
    name: 'PlanificadorRutas',
    components: {
        MultiSelectReactivo,
        draggable,
        vSelect,
        mapRoutingMachine,
        ExcelUploader
    },
    props: {
        rutaIdObtener: String
    },
    data() {
        return {
            modoSeleccion: 'manual',
            zonaSeleccionada: null,
            zonas: [],
            puntosDeZona: [],
            plantillasRutas: [],
            plantillasElegidas: [],
            puntoPartidaSeleccionado: null,
            originLatCoodenades: '',
            originLongCoodenades: '',
            estimacionesTiempos: [],
            puntosDeEntrega: [],
            habilitarGuardado: false,
            persona: {},
            drag: false,
            apiExecuted: false,
            puntosExistentes: [],
            dragIndex: null,
            // Almacena datos adicionales de los puntos importados desde Excel
            datosAdicionalesPuntos: {}
        }
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },
        todosLosPuntos() {
            if (this.puntoPartidaSeleccionado) {
                return [this.puntoPartidaSeleccionado, ...this.plantillasElegidas];
            }
            return this.plantillasElegidas;
        },
        validarFechaEntrega() {
            return this.apiExecuted && this.puntosDeEntrega.some(point =>
                point.id !== this.puntoPartidaSeleccionado?.id && !point.fechaHoraEntrega
            );
        },
        plantillasRutasMultiSelect() {
            return this.plantillasRutas.map(item => ({
                ...item,
                // Agregamos el texto extra a la propiedad que queremos mostrar
                detallePlantilla: item.lugarEntrega  +" ---> " + (item.nombreCliente ?  item.nombreCliente : " ") + "(" + item.longUbicacionEntrega + ", " + item.latUbicacionEntrega + ")"
            }));
        }
    },
    watch: {
        plantillasElegidas: {
            handler(newVal) {
                const uniquePoints = new Map();

                this.puntosDeEntrega = newVal.filter(point => {
                    if (uniquePoints.has(point.id) || this.puntosExistentes.some(p => p.plantillaRutasId === point.id)) {
                        this.mostrarNotificacion('warning', 'Punto duplicado', `El punto de entrega "${point.lugarEntrega}" ya existe o ha sido añadido.`);
                        return false;
                    }
                    uniquePoints.set(point.id, true);
                    return true;
                }).map(point => {
                    // Datos base del punto
                    const puntoDatos = {
                        ...point,
                        fechaHoraInicio: new Date("2000-01-01"),
                        fechaHoraEntrega: null,
                        tiempoDescarga: 'No estipulado',
                        estadoPuntoEntrega: 'No ha iniciado',
                        plantillaRutasId: point.id,
                        puntosEntregaGeneralesId: this.rutaIdObtener,
                        empresaId: this.persona.empresa?.id,
                        numeroDocumentoEntrega: '',
                        descripcionPuntoEntrega: ''
                    };

                    // Si hay datos adicionales para este punto, los añadimos
                    if (this.datosAdicionalesPuntos[point.id]) {
                        const datosPunto = this.datosAdicionalesPuntos[point.id];

                        if (datosPunto.numeroDocumentoEntrega) {
                            puntoDatos.numeroDocumentoEntrega = datosPunto.numeroDocumentoEntrega;
                        }

                        if (datosPunto.descripcionPuntoEntrega) {
                            puntoDatos.descripcionPuntoEntrega = datosPunto.descripcionPuntoEntrega;
                        }

                        if (datosPunto.fechaHoraEntrega) {
                            puntoDatos.fechaHoraEntrega = datosPunto.fechaHoraEntrega;
                        }
                    }

                    return puntoDatos;
                });
            },
            immediate: true
        },
        zonaSeleccionada(newZona) {
            if (newZona) {
                const plantillasDeZona = this.plantillasRutas.filter(plantilla =>
                    plantilla.ubicacion.toLowerCase() === newZona.toLowerCase()
                );

                plantillasDeZona.forEach(plantilla => {
                    if (!this.plantillasElegidas.some(p => p.id === plantilla.id) &&
                        !this.puntosExistentes.some(p => p.plantillaRutasId === plantilla.id)) {
                        this.plantillasElegidas.push(plantilla);
                    } else {
                        this.mostrarNotificacion('info', 'Punto ya existente', `El punto de entrega "${plantilla.lugarEntrega}" ya está en la lista o ya existe.`);
                    }
                });
            }
        }
    },
    async mounted() {
        this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));
        await this.getPuntosEntregaData();
        await this.obtenerPuntosExistentes();
    },
    methods: {
        // Métodos para Excel
        procesarImportacion(resultado) {
            const { plantillasEncontradas, plantillasNoEncontradas, datosAdicionales, total } = resultado;

            // Guardar los datos adicionales para usarlos al crear los puntos
            this.datosAdicionalesPuntos = datosAdicionales;

            // Añadir las plantillas encontradas
            if (plantillasEncontradas.length > 0) {
                plantillasEncontradas.forEach(plantilla => {
                    this.plantillasElegidas.push(plantilla);
                });

                this.mostrarNotificacion(
                    'success',
                    'Importación exitosa',
                    `Se importaron ${plantillasEncontradas.length} de ${total} puntos de entrega`
                );
            } else {
                this.mostrarNotificacion(
                    'warning',
                    'Sin puntos nuevos',
                    'No se encontraron puntos nuevos para importar'
                );
            }

            // Mostrar IDs no encontrados si hay alguno
            if (plantillasNoEncontradas.length > 0) {
                const idsNoEncontrados = plantillasNoEncontradas.join(', ');
                this.mostrarNotificacion(
                    'info',
                    'IDs no encontrados',
                    `Los siguientes IDs no se encontraron: ${idsNoEncontrados}`
                );
            }
        },

        mostrarMensaje(mensaje) {
            this.mostrarNotificacion(mensaje.tipo, mensaje.titulo, mensaje.mensaje);
        },

        limpiarDatosExcel() {
            // Este método se llama cuando se cancela la importación
            console.log('Datos de Excel limpiados');
        },

        async saveData() {
            try {
                console.log("INICIADO");

                const form = this.$refs.form;
                if (!form.checkValidity()) {
                    this.mostrarNotificacion('warning', 'Campos incompletos', 'Por favor, completa todos los campos requeridos');
                    return;
                }

                // Verificar si hay puntos duplicados con los existentes
                const duplicates = this.puntosDeEntrega.filter(point =>
                    this.puntosExistentes.some(p => p.plantillaRutasId === point.plantillaRutasId)
                );

                if (duplicates.length > 0) {
                    const duplicateNames = duplicates.map(d => d.lugarEntrega).join(', ');
                    this.mostrarNotificacion('error', 'Puntos duplicados', `No se pueden guardar puntos que ya existen: ${duplicateNames}`);
                    return;
                }

                // Continuar con el guardado de los datos
                const puntosEntrega = this.puntosDeEntrega
                    .filter(point => point.id !== this.puntoPartidaSeleccionado?.id)
                    .map((point) => ({
                        distanciaRecorrida: point.distanciaRecorrida,
                        tiempoRecorrido: point.tiempoRecorrido,
                        fechaHoraInicio: point.fechaHoraInicio,
                        fechaHoraEntrega: point.fechaHoraEntrega,
                        tiempoDescarga: point.tiempoDescarga,
                        estadoPuntoEntrega: point.estadoPuntoEntrega,
                        plantillaRutasId: point.plantillaRutasId,
                        puntosEntregaGeneralesId: point.puntosEntregaGeneralesId,
                        numeroDocumentoEntrega: point.numeroDocumentoEntrega,
                        descripcionPuntoEntrega: point.descripcionPuntoEntrega,
                        empresaId: point.empresaId,
                    }));

                console.log("PUNTOS DE ENTREGA A GUARDAR:", puntosEntrega);

                const results = await Promise.all(
                    puntosEntrega.map(punto =>
                        this.$store.dispatch("hl_post", {
                            path: "EntregasApp/CreatePuntosEntrega",
                            data: punto,
                        })
                    )
                );

                if (results.every(result => result.success)) {
                    this.mostrarNotificacion('success', 'Éxito', 'Todos los puntos de entrega se registraron correctamente');
                    await this.obtenerPuntosExistentes(); // Actualizar la lista de puntos existentes
                } else {
                    throw new Error('Algunos puntos de entrega no se pudieron registrar');
                }
            } catch (error) {
                console.error("Error al guardar los puntos de entrega:", error);
                this.mostrarNotificacion('error', 'Error', 'No se pudieron guardar todos los puntos de entrega');
            } finally {
                console.log("FINALIZADO");
            }
        },

        async obtenerPuntosExistentes() {
            try {
                const res = await this.$store.dispatch("hl_get", {
                    path: `EntregasApp/GetPuntosEntrega/${this.rutaIdObtener}`,
                });

                if (res.success && res.data) {
                    this.puntosExistentes = res.data;
                    console.log("Puntos de entrega existentes:", this.puntosExistentes);
                }
            } catch (error) {
                console.error("Error al obtener los puntos de entrega existentes:", error);
                this.mostrarNotificacion('error', 'Error', 'No se pudieron obtener los puntos de entrega existentes');
            }
        },

        mostrarNotificacion(tipo, titulo, mensaje) {
            Swal.fire({
                icon: tipo,
                title: titulo,
                text: mensaje,
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            });
        },

        actualizarFechaHoraEntrega(index, fecha) {
            this.puntosDeEntrega[index].fechaHoraEntrega = fecha;
        },
        removePuntoEntrega(index, event) {
            if (event) {
                event.preventDefault();
            }
            this.plantillasElegidas.splice(index, 1);
            this.$nextTick(() => {
                this.puntosDeEntrega = this.plantillasElegidas.map(point => ({
                    ...point,
                    fechaHoraInicio: new Date("2000-01-01"),
                    fechaHoraEntrega: null,
                    tiempoDescarga: 'No estipulado',
                    estadoPuntoEntrega: 'No ha iniciado',
                    plantillaRutasId: point.id,
                    puntosEntregaGeneralesId: this.rutaIdObtener,
                    empresaId: this.persona.empresa?.id,
                }));
            });
        },
        async getPuntosEntregaData() {
            try {
                const path = `EntregasApp/GetPlantillasRutasByEmpresa/${this.persona.empresa.id}`;
                const response = await this.$store.dispatch("get", { path });

                if (response && response.data) {
                    this.plantillasRutas = response.data;
                    this.zonas = [...new Set(this.plantillasRutas.map(plantilla => plantilla.ubicacion))];
                    console.log("Plantillas de entrega obtenidas:", this.plantillasRutas);
                    console.log("Zonas obtenidas:", this.zonas);
                } else {
                    console.error("Error al obtener las plantillas de entrega. Respuesta vacía.");
                    alert("Error al obtener las plantillas de entrega.");
                }
            } catch (error) {
                console.error("Hubo un error al hacer la solicitud:", error);
                alert("Hubo un error al obtener las plantillas de entrega.");
            }
        },
        actualizarCoordenadasIniciales() {
            if (this.puntoPartidaSeleccionado) {
                this.originLatCoodenades = this.puntoPartidaSeleccionado.latUbicacionEntrega;
                this.originLongCoodenades = this.puntoPartidaSeleccionado.longUbicacionEntrega;
            }
        },
        async getUbicationApi() {
            if (!this.puntoPartidaSeleccionado) {
                Swal.fire({
                    title: "Error",
                    text: "Por favor, seleccione un punto de partida antes de calcular las rutas.",
                    icon: "error",
                    confirmButtonColor: "#186bdd",
                    confirmButtonText: "Entendido",
                });
                return;
            }

            Swal.fire({
                title: "¿Has terminado de validar las rutas?",
                text: "Si no has terminado de validar las rutas y su orden, no podrás cambiar el orden después.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#186bdd",
                cancelButtonColor: "#F2135D",
                confirmButtonText: "Sí!",
                cancelButtonText: "Cancelar",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let currentDateTime = new Date();
                    let originLat = this.originLatCoodenades;
                    let originLong = this.originLongCoodenades;

                    try {
                        for (let i = 0; i < this.plantillasElegidas.length; i++) {
                            const destinationLat = this.plantillasElegidas[i].latUbicacionEntrega;
                            const destinationLong = this.plantillasElegidas[i].longUbicacionEntrega;

                            console.log(`Ruta ${i + 1}:`);
                            console.log(`Origen: ${originLat},${originLong}`);
                            console.log(`Destino: ${destinationLat},${destinationLong}`);

                            // IMPORTANTE: Mapbox usa `lng,lat` en lugar de `lat,lng`
                            const origin = `${originLong},${originLat}`;
                            const destination = `${destinationLong},${destinationLat}`;

                            const data = await this.$store.dispatch("hl_get", {
                                path: `EntregasApp/GetApiMapbox?origin=${origin}&destination=${destination}`
                            });

                            if (data.routes && data.routes.length > 0) {
                                const route = data.routes[0];

                                // Mapbox usa `distance` en metros y `duration` en segundos
                                const distance = (route.distance / 1000).toFixed(2) + " km"; // Convertimos metros a km
                                const durationInTraffic = Math.floor(route.duration / 60); // Convertimos segundos a minutos
                                const arrivalTime = new Date(currentDateTime.getTime() + route.duration * 1000);

                                console.log(`Distancia: ${distance}`);
                                console.log(`Duración estimada: ${durationInTraffic} minutos`);
                                console.log(`Hora estimada de llegada: ${arrivalTime.toLocaleTimeString()}`);

                                this.estimacionesTiempos.push({
                                    distancia: distance,
                                    duracionConTrafico: `${durationInTraffic} minutos`,
                                    horaEstimada: arrivalTime.toLocaleTimeString(),
                                });

                                // Actualizar puntos de entrega
                                this.puntosDeEntrega = this.puntosDeEntrega.map((point, index) => ({
                                    ...point,
                                    distanciaRecorrida: this.estimacionesTiempos[index]?.distancia || null,
                                    tiempoRecorrido: this.estimacionesTiempos[index]?.duracionConTrafico || null,
                                }));

                                // Actualizar la hora de referencia
                                currentDateTime = arrivalTime;
                                this.habilitarGuardado = true;
                            } else {
                                console.error(`Error en la solicitud para la ruta ${i + 1}:`, data);
                            }

                            // Mover el origen al destino para la siguiente iteración
                            originLat = destinationLat;
                            originLong = destinationLong;
                        }
                    } catch (error) {
                        console.error('Error en la solicitud:', error);
                    }
                    this.apiExecuted = true;
                }
            });
        },
        limpiarTodasLasRutas() {
            this.puntosDeEntrega = [];
            this.plantillasElegidas = [];
            this.puntosDeZona = [];
            this.zonaSeleccionada = null;
            this.habilitarGuardado = false;
            this.apiExecuted = false;
            this.puntoPartidaSeleccionado = null;
            this.originLatCoodenades = '';
            this.originLongCoodenades = '';
            this.estimacionesTiempos = [];
            this.datosAdicionalesPuntos = {};
        },
    }
}
</script>

<style>
.modal-xl {
    max-width: 80vw !important;
    width: 80vw !important;
}

.modal-body {
    padding: 0 !important;
}
</style>

<style scoped>
/* Estilos para las tarjetas de selección */
.selection-card-wrapper {
    flex: 1;
    min-width: 250px;
    max-width: 350px;
    margin: 0 10px 20px;
}

.selection-card {
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #4a6cf7;
    height: 100%;
}

.selection-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.selection-card.selected {
    border-color: #4a6cf7;
    background-color: #f0f4ff;
}

.selection-card.selected b {
    color: #424347;
}


.icon-wrapper {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #f0f4ff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 15px;
}

.selection-card.selected .icon-wrapper {
    background-color: #4a6cf7;
    color: white;
}

.card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.form-control.date {
    width: 11vw;
}

.selection-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}

.card-content {
    padding: 1.25rem;
    text-align: center;
}

.icon-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-bottom: 0.75rem;
    transition: transform 0.3s ease;
}

.selection-card:hover .icon-wrapper {
    transform: scale(1.1);
}

.selection-card h3 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #a8a8a8;
    margin-bottom: 0.5rem;
    transition: color 0.3s ease;
}

.selection-card:hover h3,
.selection-card.selected h3 {
    color: #007bff;
}

.selection-card.selected .icon-wrapper {
    background: linear-gradient(135deg, #0056b3, #4d0bd1);
}

.handle {
    cursor: move;
}

.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}

.flip-list-move {
    transition: transform 0.5s;
}

.puntos-entrega-container {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    max-width: 100%;
}

/* Encabezado con contador */
.header-summary {
    display: flex;
    justify-content: center;
    margin-bottom: 1.5rem;
}

.counter-badge {
    border-left: 4px solid #0d6efd;
    padding: 0.75rem 1.5rem;
    border-radius: 4px;
    font-weight: 600;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* Tarjeta principal */
.delivery-points-card {
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    padding: 1.5rem;
}

/* Lista de puntos de entrega */
.delivery-points-list {
    list-style: none;
    padding: 0;
}

/* Elemento de punto de entrega */
.delivery-point-item {
    display: flex;
    margin-bottom: 1.5rem;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
    transition: all 0.3s ease;
}

.delivery-point-item:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.delivery-point-item.dragging {
    opacity: 0.7;
    transform: scale(1.02);
}

/* Línea de tiempo */
.timeline-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem 0.5rem;
    /* background-color: #f0f0f0; */
    color: black !important;
}

.timeline-line {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 2px;
    background-color: #0d6efd;
    z-index: 1;
}

.point-number {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0d6efd;
    border-radius: 50%;
    font-weight: bold;
    z-index: 2;
    cursor: move;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* 
.point-number span {
    color: white !important;
} */

.point-number.disabled {
    cursor: default;
    background-color: #6c757d;
}

/* Contenido del punto de entrega */
.delivery-point-content {
    flex: 1;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

/* Cabecera con ID y lugar */
.point-header {
    display: flex;
    gap: 1rem;
    margin-bottom: 0.5rem;
}

.point-id,
.point-location {
    display: flex;
    align-items: flex-start;
    /* background-color: #fff; */
    border-radius: 6px;
    padding: 0.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
}

.point-id {
    flex: 1;
}

.point-location {
    flex: 2;
}

.id-input {
    height: 32px;
    font-size: 0.9rem;
}

.location-title {
    margin: 0;
    font-size: 1rem;
    padding: 0.25rem 0;
}

/* Descripción */
.point-description {
    display: flex;
    align-items: flex-start;
    /* background-color: #fff; */
    border-radius: 6px;
    padding: 0.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
    margin-bottom: 0.5rem;
}

.description-textarea {
    font-size: 0.9rem;
    resize: vertical;
    min-height: 60px;
}

/* Sección de información de entrega */
.delivery-info-section {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
}

.info-card {
    flex: 1;
    min-width: 150px;
    display: flex;
    align-items: flex-start;
    padding: 0.5rem;
    /* background-color: #fff; */
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
}

.info-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background-color: #e9f5ff;
    color: #0d6efd;
    border-radius: 6px;
    margin-right: 0.5rem;
    flex-shrink: 0;
}

.info-content {
    flex: 1;
}

.info-content label {
    display: block;
    font-size: 0.75rem;
    font-weight: 600;
    /* color: #6c757d; */
    margin-bottom: 0.25rem;
}

.info-content p {
    margin: 0;
    font-size: 0.85rem;
}



/* Botones de acción */
.action-buttons {
    display: flex;
    align-items: center;
    padding: 0 1rem;
}

.delete-button {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #dc3545;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.delete-button:hover {
    background-color: #c82333;
}

/* Sección de botones principales */
.action-section {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
}

.action-button {
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 4px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
}

.get-times-button {
    background-color: #0d6efd;
    color: white;
}

.get-times-button:hover {
    background-color: #0b5ed7;
}

.save-button {
    background-color: #198754;
    color: white;
}

.save-button:hover {
    background-color: #157347;
}

/* Animaciones para la lista */
.delivery-point-enter-active,
.delivery-point-leave-active {
    transition: all 0.5s ease;
}

.delivery-point-enter-from,
.delivery-point-leave-to {
    opacity: 0;
    transform: translateY(30px);
}

.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}

/* Responsive */
@media (max-width: 1200px) {
    .info-card {
        min-width: 120px;
    }

    .point-header {
        flex-direction: column;
    }

    .point-id,
    .point-location {
        width: 100%;
    }
}

@media (max-width: 992px) {
    .info-card {
        min-width: 45%;
    }
}

@media (max-width: 768px) {
    .delivery-point-item {
        flex-direction: column;
    }

    .timeline-container {
        flex-direction: row;
        padding: 0.5rem;
        width: 100%;
    }

    .timeline-line {
        width: 100%;
        height: 2px;
        top: 50%;
        transform: translateY(-50%);
    }

    .action-buttons {
        justify-content: flex-end;
        padding: 0.5rem 1rem;
    }

    .info-card {
        min-width: 100%;
    }
}
</style>